import React from "react";
import style from "./FallBackText.module.scss";
import cls from "classnames";
export var FallBackText = function FallBackText(props) {
  var _props$readonlyStyle;
  return /*#__PURE__*/React.createElement("p", {
    style: (_props$readonlyStyle = props.readonlyStyle) !== null && _props$readonlyStyle !== void 0 ? _props$readonlyStyle : {},
    className: cls(style.fallBackText)
  }, props.children);
};